import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { BoughtInquiryStatus, InquiryServiceType, InquiryStatus } from '@webapp/core/enums';


export const getStringFromEnumValue = (enumType: any, value: number): string => {
  for (const key in enumType) {
    if (enumType[key] === value) {
      return key;
    }
  }
  return 'Unknown';
}


@Injectable({ providedIn: 'root' })
@Pipe({ name: 'inquiryStatusPipe' })
export class InquiryStatusPipe implements PipeTransform {

  constructor() {
  }

  transform(status: InquiryStatus): string {
    switch (status) {
      case InquiryStatus.DRAFT:
        return 'Entwurf'
      case InquiryStatus.OPEN:
        return 'Offen'
      case InquiryStatus.ACCEPTED:
        return 'Akzeptiert'
      case InquiryStatus.OPEN_FOR_BIDS:
        return 'Offen für Angebote'
      case InquiryStatus.WAITING_FOR_ACCEPTANCE:
        return 'Warten auf Akzeptanz'
      case InquiryStatus.ASSIGNED:
        return 'In Auftrag gegeben'
      case InquiryStatus.DONE:
        return 'Abgeschlossen'
      case InquiryStatus.ARCHIVED:
        return 'Archiviert'
      case InquiryStatus.DELETED:
        return 'Gelöscht'
      default: {
        console.error(`status ${status} is unknown`);
        return getStringFromEnumValue(InquiryStatus, status)
      }
    }
  }
}


@Injectable({ providedIn: 'root' })
@Pipe({ name: 'serviceType' })
export class ServiceTypePipe implements PipeTransform {
  transform(service?: string | number) {
    const serviceType = typeof service === 'string' ? Number.parseInt(service as string) : service;

    switch (serviceType) {
      case InquiryServiceType.MOVE_AND_CLEAN:
        return 'Umzug und Reinigung';
      case InquiryServiceType.MOVE:
        return 'Nur Umzug';
      case InquiryServiceType.CLEAN:
        return 'Nur Reinigung';
      default: {
        return ''
      }
    }
  }
}


@Injectable({ providedIn: 'root' })
@Pipe({ name: 'boughtInquiryStatus' })
export class BoughtInquiryStatusPipe implements PipeTransform {
  transform(service?: string | number) {
    const serviceType = typeof service === 'string' ? Number.parseInt(service as string) : service;

    switch (serviceType) {
      case BoughtInquiryStatus.UNKNOWN:
        return 'Unbekannt';
      case BoughtInquiryStatus.OPEN:
        return 'Offene Anfrage';
      case BoughtInquiryStatus.SENT:
        return 'Offerte versendet';
      case BoughtInquiryStatus.ACCEPTED:
        return 'Offerte akzeptiert';
      case BoughtInquiryStatus.REJECTED:
        return 'Offerte abgelehnt';
      case BoughtInquiryStatus.COMPLETED:
        return 'Auftrag ausgeführt';
      case BoughtInquiryStatus.DELETED:
        return 'Gelöscht';
      default:
        return 'Unbekannt'
    }
  }
}

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'boughtInquiryStatusClass' })
export class BoughtInquiryStatusClassPipe implements PipeTransform {
  transform(service?: string | number) {
    const serviceType = typeof service === 'string' ? Number.parseInt(service as string) : service;

    switch (serviceType) {
      case BoughtInquiryStatus.UNKNOWN:
        return 'unknown-bid-status';
      case BoughtInquiryStatus.OPEN:
        return 'open-bid-status';
      case BoughtInquiryStatus.SENT:
        return 'sent-bid-status';
      case BoughtInquiryStatus.ACCEPTED:
        return 'accepted-bid-status';
      case BoughtInquiryStatus.REJECTED:
        return 'rejected-bid-status';
      case BoughtInquiryStatus.COMPLETED:
        return 'completed-bid-status';
      case BoughtInquiryStatus.DELETED:
        return 'deleted-bid-status';
      default:
        return ''
    }
  }
}


@Injectable({ providedIn: 'root' })
@Pipe({ name: 'inquiryAvailability' })
export class InquiryAvailability implements PipeTransform {
  transform(value?: string): string {
    switch (value) {
      case 'morgens':
        return 'Morgens: 8.00-11.30 Uhr';
      case 'mittags':
        return 'Mittags: 11.30-13.00 Uhr';
      case 'nachmittags':
        return 'Nachmittags: 13.00-17.00 Uhr';
      case 'abends':
        return 'Abends: ab 17.00 Uhr';
      case 'durchgehend':
        return 'Durchgehend erreichbar';
      default:
        return value ?? '-';
    }
  }
}

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'inquiryObjectType' })
export class InquiryObjectType implements PipeTransform {
  transform(value?: string): string {
    switch (value) {
      case 'apartment':
        return 'Wohnung';
      case 'single_family_house':
        return 'Einfamilienhaus';
      case 'office':
        return 'Büro';
      default:
        return value ?? '-';
    }
  }
}

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'inquiryRooms' })
export class InquiryRooms implements PipeTransform {
  transform(value?: string): string {
    return value ? `${value} Zimmer` : '-';
  }
}

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'inquiryFloor' })
export class InquiryFloor implements PipeTransform {
  transform(value?: string): string {
    switch (value) {
      case 'ground_floor':
        return 'EG';
      case '1st_floor':
        return '1. Stock';
      case '2nd_floor':
        return '2. Stock';
      case '3rd_floor':
        return '3. Stock';
      case '4th_floor':
        return '4. Stock';
      case '5th_floor':
        return '5. Stock';
      case '6th_floor':
        return '6. Stock';
      case '7th_floor':
        return '7. Stock';
      case '8th_floor':
        return '8. Stock';
      case '9th_floor':
        return '9. Stock';
      case '10th_floor':
        return '10. Stock';
      case '10th_floor_plus':
        return '10+ Stock';
      default:
        return value || '-';
    }
  }
}
